import { BiCategory, BiExport, BiMailSend, BiImport } from 'react-icons/bi';
import {
	RiHome5Line,
	RiUserSearchLine,
	RiRepeatLine,
	RiShoppingCartLine,
	RiArrowDropUpLine,
	RiArrowDropDownLine,
} from 'react-icons/ri';
import { CgProfile } from 'react-icons/cg';
import {
	BsListTask,
	BsPlusSquareDotted,
	BsTrash,
	BsShield,
	BsBoxSeam,
	BsEye,
	BsEyeSlash,
	BsCheckCircleFill,
	BsCheckCircle,
	BsThreeDotsVertical,
	BsArrowLeft,
  BsPencil,
  BsGlobe
} from 'react-icons/bs';
import { MdMyLocation, MdClose } from 'react-icons/md';
import { VscCalendar } from 'react-icons/vsc';
import { FiSearch,FiEdit,FiHash,FiPlus,FiInfo,FiDollarSign,FiX,FiBriefcase,FiTag,FiRefreshCw } from 'react-icons/fi';
import { SiAddthis } from 'react-icons/si';
import { FaTrash, FaRegEdit, FaToggleOn, FaToggleOff, FaTrashAlt } from 'react-icons/fa';
import { IoIosArrowBack, IoIosArrowForward, IoMdLogOut } from 'react-icons/io';
import { TbClipboardText, TbTruckDelivery } from 'react-icons/tb';
import { VscChecklist } from 'react-icons/vsc';
import { GrFormClose } from 'react-icons/gr';
import { BsClockHistory,BsPersonPlus,BsCalendar,BsInbox,BsChevronLeft,BsChevronRight,BsExclamationTriangle,BsCardText,BsBank,BsCreditCard,
  BsCash,BsAward,BsFilePdf,BsUpload,BsPlus,BsGift,BsCashStack,BsX,BsFileText,BsXCircle,BsArrowLeftRight,BsReceipt,BsArrowRight,BsClock,BsGraphUp,BsWallet,BsGrid,BsCart,BsBox,BsPeople,BsBuilding } from 'react-icons/bs';

export const icons = {
	BiCategory,
  BsFileText,
  FiHash,
  FiEdit,
  BsGift,
  FiInfo,
  BsPersonPlus,
  BsArrowLeftRight,
  FiX,
  FiDollarSign,
  BsCashStack,
  BsXCircle,
  BsCalendar,
  BsPlus,
  BsGlobe,
  BsX,
  BsReceipt,
  BsInbox,
  BsArrowRight,
  BsCash,
  BsChevronLeft,
  BsChevronRight,
  BsBuilding,
  BsExclamationTriangle,
  FiBriefcase,
  FiTag,
  BsCardText,
  FiRefreshCw,
  BsBox,
  BsPeople,
  BsWallet,
  BsCart,
  BsGrid,
  BsClock,
  BsGraphUp,
  BsClockHistory,
  BsAward,
  BsBank,
  BsCreditCard,
	BiMailSend,
	BsTrash,
	BsPlusSquareDotted,
	BiExport,
	BiImport,
	RiHome5Line,
	BsArrowLeft,
	RiShoppingCartLine,
	RiArrowDropDownLine,
	RiUserSearchLine,
	TbTruckDelivery,
	RiRepeatLine,
	RiArrowDropUpLine,
	CgProfile,
	TbClipboardText,
	BsBoxSeam,
	VscChecklist,
	BsListTask,
	BsShield,
	MdMyLocation,
	MdClose,
	VscCalendar,
	GrFormClose,
	FiSearch,
	FaTrashAlt,
	BsThreeDotsVertical,
	BsEyeSlash,
	SiAddthis,
	FaTrash,
	FaRegEdit,
	BsEye,
	IoIosArrowBack,
	IoIosArrowForward,
	IoMdLogOut,
	FaToggleOn,
	FaToggleOff,
	BsCheckCircleFill,
	BsCheckCircle,
  BsPencil,
  BsUpload,
  FiPlus,
  BsFilePdf
};
